import type { BestFill, ResolvedSymmetry } from "@pdfking/filling"
import { fill_len, FillUsedSymmetry } from "@pdfking/filling"
import { Floor } from "@pdfking/math"

import type { JobSchema } from "#internal"
import type { PrintMode } from "#internal"

import { PrintModeList } from "../../../data/PrintModeList"

export type FillPlan = {
  /** The job's print mode, corrected to the axis the fill turned over on. */
  effective_print_mode: PrintMode
  used_symmetry: ResolvedSymmetry
  /** How many subjects the fill holds, counting a turned-over pair once. */
  capacity: number
}

/** What the fill's answer settles for the job — mirrors the symmetry override
 * and the `m` capacity of Python `_get_imposition_data` (concrete.py:225-248). */
export const ResolveFillPlan = (fill: BestFill, job: JobSchema): FillPlan => {
  let effective_print_mode = job.print_mode
  let used_symmetry: ResolvedSymmetry = null

  const from_fill = FillUsedSymmetry(fill)
  if (from_fill) {
    let axis = from_fill
    // Python `strategy.is_portrait`: a fill found on the turned sheet reads its
    // axis in that frame, so it is turned back to the sheet's. The machine
    // size is landscape, so only the turned fill stands portrait.
    if (fill.height > fill.width) axis = axis === "x" ? "y" : "x"
    used_symmetry = axis
    if (job.print_mode.use_symmetry === "both") {
      effective_print_mode = PrintModeList[axis === "x" ? "bv" : "pt"]!
    }
  }

  return {
    effective_print_mode,
    used_symmetry,
    capacity: Floor(fill_len(fill) / (FillUsedSymmetry(fill) ? 2 : 1)),
  }
}
